<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <BRow
      class="mb-2"
    >
      <BCol
        cols="12"
      >
        <div
          class="card card-body p-3 rounded-lg mt-2"
        >
          <div class="d-flex flex-column flex-md-row align-items-md-center gap-5">
            <div class="flex-grow-1">
              <div class="h3">
                Good {{ greetings }}, <b class="text-primary">{{ currentUser?.name || 'Officer' }}</b>
              </div>
              <div class="h6">
                Your team performance summary for month of {{ monthLongFormatter(filters.month) }}
              </div>
            </div>
            <div>
              <BFormGroup
                label="Month"
                label-for="filterMonth"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <flat-pickr
                  id="filterMonth"
                  v-model="filters.month"
                  class="form-control"
                  placeholder="--------- ----"
                  :config="flatPickerConfig"
                />
              </BFormGroup>
            </div>
          </div>
        </div>
      </BCol>
    </BRow>
    <AreaManager
      :busy="state.busy"
      :area-managers="areaManagerTasks"
      class="mb-4 mt-4"
    />
    <!-- <Tasks
      :busy="state.busy"
      :tasks="taskSummaries"
      class="mb-4"
    /> -->
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import createDate from 'moment'
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'

import AreaManager from '@/views/audit/dashboard/AreaManagers.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MActivities from '@/mixins/maintenances/activities'
import MCustomers from '@/mixins/accounts/customers'

import { SAuditDashboard } from '@/services/audit'

// import Tasks from '@/views/audit/dashboard/Tasks.vue'

export default {

  name: 'VAuditDashboard',

  components: {
    AreaManager
    // Tasks
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl,
    MActivities,
    MCustomers
  ],

  middleware: ['auth', 'audit'],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      },
      state: {
        busy: false,
        editing: false
      },
      tasksCurrentTabIndex: 0,
      filters: {
        month: createDate().format('YYYY-MM')
      },
      taskSummaries: {
        totalRows: 0,
        rows: []
      },
      areaManagerTasks: {
        totalRows: 0,
        rows: []
      }
    }
  },

  computed: Object.assign({
    greetings () {
      const currentHourOfTheDay = createDate().hour()

      if (currentHourOfTheDay >= 3 && currentHourOfTheDay < 12) {
        return 'Morning'
      } else if (currentHourOfTheDay === 12) {
        return 'Noon'
      } else if (currentHourOfTheDay > 12 && currentHourOfTheDay < 18) {
        return 'Afternoon'
      } else if (currentHourOfTheDay >= 18 && currentHourOfTheDay < 20) {
        return 'Evening'
      } else {
        return 'Night'
      }
    }
  }, mapGetters({
    currentUser: 'auth/user'
  })),

  watch: {
    'filters.month' (month) {
      if (!month) {
        this.filters.month = createDate().format('YYYY-MM')
      } else {
        this.gridProvider()
      }
    }
  },

  mounted () {
    if (this.currentUser) {
      this.gridProvider()
    }
  },

  methods: {

    async gridProvider () {
      this.state.busy = true

      const payload = {
        schedule: this.filters.month
      }

      return SAuditDashboard.getActivitySummaries(payload).then(
        ({ data: { activity_summaries: taskSummaries, area_sales_summaries: taskProgress } }) => {
          this.taskSummaries = {
            totalRows: Array.from(taskSummaries || []).length,
            rows: taskSummaries || []
          }

          this.areaManagerTasks = {
            totalRows: Array.from(taskProgress || []).length,
            rows: taskProgress || []
          }
        }
      ).catch(() => {
        this.taskSummaries = {
          totalRows: 0,
          rows: []
        }
        this.areaManagerTasks = {
          totalRows: 0,
          rows: []
        }
      }).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
